import React from 'react';

const HomeIcon = () => {
  const iconColor = '#006E95';
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.49037 0.580248C5.36554 0.473251 5.18134 0.473251 5.05651 0.580248L0.273438 4.68002V9.5C0.273438 10.0523 0.721153 10.5 1.27344 10.5H3.9401C4.1242 10.5 4.27344 10.3508 4.27344 10.1667V8.16667C4.27344 7.61438 4.72115 7.16667 5.27344 7.16667C5.82572 7.16667 6.27344 7.61438 6.27344 8.16667V10.1667C6.27344 10.3508 6.42268 10.5 6.60677 10.5H9.27344C9.82572 10.5 10.2734 10.0523 10.2734 9.5V4.68002L5.49037 0.580248Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default HomeIcon;
